import * as ng from 'angular';

export const OrderArchidrive: ng.FilterFactory = ($filter: ng.IFilterService) => {
    return (items, field, reverse) => {
        let filtered = [];
        ng.forEach(items, (item) => {
            filtered.push(item);
        });
        filtered.sort((a, b) => {
            switch (field) {
                case 'dateCreated':
                    /* tslint:disable:no-string-literal */
                    let d1 = new Date(a[field]['value']);
                    let d2 = new Date(b[field]['value']);
                    return (d1 > d2 ? 1 : -1);
                case 'name':
                    return (a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1);
                default:
                    return (a[field] > b[field] ? 1 : -1);
            }
        });
        if (reverse) {
            filtered.reverse();
        }
        return filtered;
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/order-archidrive.filter.ts